import { render } from "./VideoPreview.vue?vue&type=template&id=0dc0f630"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=0dc0f630&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__